<template>
  <b-tooltip
    :label="$t('compCarbonAdminUserMenu.tooltip')"
    type="is-black"
    position="is-right"
    multilined
    :active="adminStore.entity === null"
    style="width: 100%"
  >
    <b-menu-item
      :active="buffer === 'all-ghgi' || buffer === 'ghgi-comparison'"
      :expanded="buffer === 'all-ghgi' || buffer === 'ghgi-comparison'"
      @click="activate('all-ghgi')"
      :disabled="adminStore.entity === null"
      data-testid="menu-ghgis"
    >
      <template slot="label" slot-scope="props">
        <b-icon icon="thermometer"></b-icon>
        {{ $t('carbon') }}
        <b-icon
          class="is-pulled-right"
          :icon="props.expanded ? 'caret-down' : 'caret-up'"
        >
        </b-icon>
      </template>
      <b-menu-item
        :active="buffer === 'all-ghgi'"
        @click="activate('all-ghgi')"
        :disabled="adminStore.entity === null"
      >
        <template slot="label">
          <b-icon icon="thermometer"></b-icon>
          {{ $t('compCarbonAdminUserMenu.ghgis') }}
        </template>
      </b-menu-item>
      <b-menu-item
        :active="buffer === 'ghgi-comparison'"
        @click="activate('ghgi-comparison')"
        :disabled="adminStore.entity === null"
      >
        <template slot="label">
          <b-icon icon="line-chart"></b-icon>
          {{ $t('compCarbonAdminUserMenu.compare-ghgis') }}
        </template>
      </b-menu-item>
    </b-menu-item>
  </b-tooltip>
</template>

<script>
import { useAdminStore } from '@/stores/admin.js'

export default {
  name: 'UserMenu',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  setup () {
    const adminStore = useAdminStore()
    return { adminStore }
  },
  data () {
    return {
      buffer: this.value
    }
  },
  watch: {
    value: function () {
      this.buffer = this.value
    }
  },
  methods: {
    activate: function (val) {
      this.buffer = val
      this.$emit('input', this.buffer)
    }
  }
}
</script>
